module.exports = __webpack_public_path__ + "static/media/PICCO.576b5a10.png";